module.exports = __webpack_public_path__ + "img/np.4755e686.png";